import { styled } from 'styled-components'

export const Main = styled.main`
  align-items: center;
  background-color: #fafafa;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 12;
`

export const Section = styled.section`
  max-width: 600px;
  margin: 0 auto;
`

export const BoxButtons = styled.div`
  display: flex;
  justify-content: center;
`
